import { MENU_BIG, MENU_SMALL } from '@constants/menu.contant';
import { makeStyles } from '@mui/styles';

const useMainContainerStyles = makeStyles({
	contentBig: {
		width: `calc(100% - ${MENU_BIG})`,
		marginLeft: MENU_BIG,
	},
	contentSmall: {
		width: `calc(100% - ${MENU_SMALL})`,
		marginLeft: MENU_SMALL,
	},
});

export default useMainContainerStyles;
